@if (!embedded) {
  <app-navbar></app-navbar>
}
<div [class]="embedded ? '' : 'container-fluid mt-4'">
  @if (!embedded) {
    <a routerLink="/admin" class="back-link"><i class="bi bi-arrow-left"></i> Back to Admin</a>
    <h2 class="mb-4"><i class="bi bi-question-circle me-2"></i> Questions</h2>
  }
  <div class="card">
    <div class="card-body">
      <div class="d-flex flex-wrap align-items-center gap-3 mb-3">
        <label class="text-muted mb-0">Seed:</label>
        <select class="form-select" style="width: auto; min-width: 10rem; max-width: 18rem" [ngModel]="selectedSeedId" (ngModelChange)="selectedSeedId = $event; onSeedChange()">
          @for (s of seeds; track s.id) {
            <option [ngValue]="s.id">{{ s.name }}</option>
          }
        </select>
        <label class="text-muted mb-0">Course:</label>
        <select class="form-select w-auto" [ngModel]="filterCourseId" (ngModelChange)="onCourseChange($event)">
          @for (c of courses; track c.id) {
            <option [ngValue]="c.id">{{ c.name }}</option>
          }
        </select>
        <label class="text-muted mb-0">Subject:</label>
        <select class="form-select w-auto" [ngModel]="filterSubjectId" (ngModelChange)="onSubjectChange($event)">
          @for (s of subjects; track s.id) {
            <option [ngValue]="s.id">{{ s.name }}</option>
          }
        </select>
        <label class="text-muted mb-0">Topic:</label>
        <select class="form-select w-auto" [ngModel]="filterTopicId" (ngModelChange)="onTopicChange($event)">
          <option [ngValue]="null">All</option>
          @for (t of topics; track t.id) {
            <option [ngValue]="t.id">{{ t.name }}</option>
          }
        </select>
        <label class="text-muted mb-0">Area:</label>
        <select class="form-select w-auto" [ngModel]="filterAreaId" (ngModelChange)="filterAreaId = $event; onFilterChange()">
          <option [ngValue]="null">All</option>
          @for (a of areasForFilter; track a.id) {
            <option [ngValue]="a.id">{{ a.name }}</option>
          }
        </select>
        <div class="form-check form-check-inline ms-2">
          <input type="checkbox" class="form-check-input" id="filterRemoved" [ngModel]="filterShowRemoved" (ngModelChange)="filterShowRemoved = $event; onRemovedFilterChange()">
          <label class="form-check-label text-muted" for="filterRemoved">Removed</label>
        </div>
        <button type="button" class="btn btn-primary ms-auto" (click)="openCreate()">Create Question</button>
      </div>
      @if (error) {
        <div class="alert alert-danger">{{ error }}</div>
      }
      @if (message) {
        <div class="alert alert-success">{{ message }}</div>
      }
      @if (loading) {
        <p class="text-muted">Loading…</p>
      } @else {
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th (click)="setSort('id'); $event.stopPropagation()" class="sortable"><span class="me-1">Id</span><i [class]="'bi ' + sortIcon('id')"></i></th>
                <th (click)="setSort('areaId'); $event.stopPropagation()" class="sortable"><span class="me-1">Topic</span><i [class]="'bi ' + sortIcon('areaId')"></i></th>
                <th (click)="setSort('questionHtml'); $event.stopPropagation()" class="sortable"><span class="me-1">Question</span><i [class]="'bi ' + sortIcon('questionHtml')"></i></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (q of content; track q.id) {
                <tr class="clickable-row" (click)="openEdit(q)" role="button" tabindex="0">
                  <td>{{ q.id }}</td>
                  <td [title]="'Area: ' + areaName(q.areaId)" class="text-truncate" style="max-width: 180px;">{{ topicNameForArea(q.areaId) }}</td>
                  <td class="text-truncate" style="max-width: 280px;" [title]="stripHtml(q.questionHtml)">{{ stripHtml(q.questionHtml) }}</td>
                  <td (click)="$event.stopPropagation()">
                    <button type="button" class="btn btn-sm btn-soft-delete me-1" (click)="openSoftDeleteConfirm(q)" title="Mark removed" >Soft delete</button>
                    <button type="button" class="btn btn-sm btn-outline-danger" (click)="openDeleteConfirm(q)" >Delete</button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        @if (content.length === 0) {
          <p class="text-muted mb-0">No questions.</p>
        }
        @if (totalElements > 0) {
          <nav class="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-3" aria-label="Question pagination">
            <div class="text-muted small">
              Showing {{ paginationStartItem }}–{{ paginationEndItem }} of {{ totalElements }}
            </div>
            <div class="d-flex align-items-center gap-2">
              <select class="form-select form-select-sm w-auto" [ngModel]="pageSize" (ngModelChange)="pageSize = $event; currentPage = 0; load()">
                <option [ngValue]="10">10 per page</option>
                <option [ngValue]="20">20 per page</option>
                <option [ngValue]="50">50 per page</option>
                <option [ngValue]="100">100 per page</option>
              </select>
              <ul class="pagination pagination-sm mb-0">
                <li class="page-item" [class.disabled]="currentPage === 0">
                  <a class="page-link" href="#" (click)="goToPage(currentPage - 1); $event.preventDefault()" aria-label="Previous">Previous</a>
                </li>
                <li class="page-item" [class.disabled]="currentPage >= totalPages - 1">
                  <a class="page-link" href="#" (click)="goToPage(currentPage + 1); $event.preventDefault()" aria-label="Next">Next</a>
                </li>
              </ul>
            </div>
          </nav>
        }
      }
    </div>
  </div>
</div>

@if (detailItem) {
  <div class="modal show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ detailItem.id == null ? 'Create question' : 'Edit question #' + detailItem.id }}</h5>
          <button type="button" class="btn-close" (click)="closeDetail()"></button>
        </div>
        <div class="modal-body">
          @if (detailError) {
            <div class="alert alert-danger mb-3">{{ detailError }}</div>
          }
          <div class="row g-2 mb-2">
            <div class="col-md-4">
              <label class="form-label">Subject <span class="text-danger">*</span></label>
              <select class="form-select" [ngModel]="detailForm.subjectId" (ngModelChange)="onDialogSubjectChange($event)">
                @for (s of subjects; track s.id) {
                  <option [ngValue]="s.id">{{ s.name }}</option>
                }
              </select>
            </div>
            <div class="col-md-4">
              <label class="form-label">Topic <span class="text-danger">*</span></label>
              <select class="form-select" [ngModel]="detailForm.topicId" (ngModelChange)="onDialogTopicChange($event)">
                @for (t of dialogTopics; track t.id) {
                  <option [ngValue]="t.id">{{ t.name }}</option>
                }
              </select>
            </div>
            <div class="col-md-4">
              <label class="form-label">Area <span class="text-danger">*</span></label>
              <select class="form-select" [(ngModel)]="detailForm.areaId">
                @for (a of dialogAreas; track a.id) {
                  <option [ngValue]="a.id">{{ a.name }}</option>
                }
              </select>
            </div>
          </div>
          <div class="mb-2">
            <label class="form-label">Question HTML <span class="text-danger">*</span></label>
            @if (questionEditor) {
              <div class="NgxEditor__Wrapper border rounded">
                <ngx-editor-menu [editor]="questionEditor"></ngx-editor-menu>
                <ngx-editor [editor]="questionEditor" [(ngModel)]="detailForm.questionHtml" outputFormat="html" placeholder="Question content (HTML)..."></ngx-editor>
              </div>
            }
          </div>
          <div class="row g-2 mb-2">
            <div class="col-md-6">
              <label class="form-label">Answer A <span class="text-danger">*</span></label>
              <input type="text" class="form-control" [class.correct-answer-bg]="detailForm.correctAnswer === 'A'" [(ngModel)]="detailForm.answer1" placeholder="Answer 1" required>
            </div>
            <div class="col-md-6">
              <label class="form-label">Answer B <span class="text-danger">*</span></label>
              <input type="text" class="form-control" [class.correct-answer-bg]="detailForm.correctAnswer === 'B'" [(ngModel)]="detailForm.answer2" placeholder="Answer 2" required>
            </div>
            <div class="col-md-6">
              <label class="form-label">Answer C <span class="text-danger">*</span></label>
              <input type="text" class="form-control" [class.correct-answer-bg]="detailForm.correctAnswer === 'C'" [(ngModel)]="detailForm.answer3" placeholder="Answer 3" required>
            </div>
            <div class="col-md-6">
              <label class="form-label">Answer D <span class="text-danger">*</span></label>
              <input type="text" class="form-control" [class.correct-answer-bg]="detailForm.correctAnswer === 'D'" [(ngModel)]="detailForm.answer4" placeholder="Answer 4" required>
            </div>
          </div>
          <div class="mb-2">
            <label class="form-label">Correct answer <span class="text-danger">*</span></label>
            <select class="form-select w-auto" [(ngModel)]="detailForm.correctAnswer">
              <option value="A">A</option>
              <option value="B">B</option>
              <option value="C">C</option>
              <option value="D">D</option>
            </select>
          </div>
          <div class="mb-2">
            <label class="form-label">Explanation HTML</label>
            @if (explanationEditor) {
              <div class="NgxEditor__Wrapper border rounded">
                <ngx-editor-menu [editor]="explanationEditor"></ngx-editor-menu>
                <ngx-editor [editor]="explanationEditor" [(ngModel)]="detailForm.explanationHtml" outputFormat="html" placeholder="Explanation (HTML)..."></ngx-editor>
              </div>
            }
          </div>
          <div class="row g-2 mb-2">
            <div class="col-md-6">
              <label class="form-label">Question image IDs (comma-separated, e.g. 1,2,5)</label>
              <input type="text" class="form-control" [(ngModel)]="detailForm.questionImageIds" placeholder="1,2,5">
            </div>
            <div class="col-md-6">
              <label class="form-label">Explanation image IDs (comma-separated, e.g. 3,4)</label>
              <input type="text" class="form-control" [(ngModel)]="detailForm.explanationQuestionImageIds" placeholder="3,4">
            </div>
          </div>
          @if (detailItem.id != null) {
            <div class="form-check mb-2">
              <input type="checkbox" class="form-check-input" id="detailRemoved" [ngModel]="detailForm.removed === 1" (ngModelChange)="detailForm.removed = $event ? 1 : 0">
              <label class="form-check-label" for="detailRemoved">Removed (soft delete)</label>
            </div>
          }
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeDetail()">Cancel</button>
          <button type="button" class="btn btn-primary" [disabled]="detailSaving" (click)="save()">Save</button>
        </div>
      </div>
    </div>
  </div>
}

@if (deleteItem) {
  <div class="modal show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Hard delete question</h5>
          <button type="button" class="btn-close" (click)="closeDeleteConfirm()"></button>
        </div>
        <div class="modal-body">
          @if (deleteError) {
            <div class="alert alert-danger">{{ deleteError }}</div>
          }
          <p>Permanently delete question <strong>#{{ deleteItem.id }}</strong>? This cannot be undone. Use &quot;Soft delete&quot; to only hide it.</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeDeleteConfirm()">Cancel</button>
          <button type="button" class="btn btn-danger" (click)="confirmHardDelete()" >Delete</button>
        </div>
      </div>
    </div>
  </div>
}

@if (softDeleteItem) {
  <div class="modal show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Soft delete question</h5>
          <button type="button" class="btn-close" (click)="closeSoftDeleteConfirm()"></button>
        </div>
        <div class="modal-body">
          <p>Mark question <strong>#{{ softDeleteItem.id }}</strong> as removed? It will be hidden from users but not deleted.</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeSoftDeleteConfirm()">Cancel</button>
          <button type="button" class="btn btn-soft-delete" (click)="confirmSoftDelete()" >Soft delete</button>
        </div>
      </div>
    </div>
  </div>
}
